<template>
  <div class="sellCollect padd30">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="按商品汇总" name="good" class="pad10_t">
        <div class="flex flex_wrap">
          <div class="pad20_r pad20_b">
            <span class="pad10_r">时间</span>
            <el-date-picker
              v-model="time"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div class="pad20_r pad20_b">
            <span class="pad10_r">订单状态</span>
            <el-select v-model="orderStatus" placeholder="请选择" class="w110">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="pad20_r pad20_b">
            <span class="pad10_r">商品分类</span>
            <el-select v-model="classifyId" filterable clearable placeholder="请选择" @change="classifyIdChange">
              <el-option v-for="item in goodsClassifies" :key="item.classifyId" :label="item.classifyName" :value="item.classifyId"> </el-option>
            </el-select>
          </div>
          <div class="pad20_r pad20_b">
            <span class="pad10_r">商品</span>
            <el-select v-model="goodsId" filterable clearable placeholder="请选择">
              <el-option v-for="item in classifyGoodsMap" :key="item.goodsId" :label="item.name" :value="item.goodsId"> </el-option>
            </el-select>
          </div>
          <div class="pad20_b">
            <el-button type="primary" @click="query(0)">查询</el-button>
            <el-button type="primary" class="mar30_l" @click="exportSellCollectGoods">导出</el-button>
            <el-button type="primary" @click="resetGood">重置</el-button>
          </div>
        </div>
        <div class="box20"></div>
        <div v-loading="tableLoad" class="min_width1000">
          <el-table
            :row-style="rowStyle"
            class="goodsOrderGroup"
            :data="tableData"
            :span-method="objectSpanMethodGoods"
            border
            style="width: 100%; min-width: 1000px"
          >
            <el-table-column label="商品编号">
              <template slot-scope="scope">
                <span class="c_blue">{{ scope.row.goodsIdStr }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="goodsName" label="货品名称"> </el-table-column>
            <el-table-column prop="customerName" label="客户"> </el-table-column>
            <el-table-column prop="goodsQuantityAll" label="销售数量"> </el-table-column>
            <el-table-column prop="mSUnit" label="销售单位"> </el-table-column>
            <el-table-column prop="finalUnitConverAll" label="结算数量"> </el-table-column>
            <el-table-column prop="goodsSpec" label="结算单位"> </el-table-column>
            <el-table-column prop="sellFactPrice" label="结算单价"> </el-table-column>
            <el-table-column prop="totalAmount" label="总价（元）"> </el-table-column>
          </el-table>
          <!--<div>

          </div>
          <div class="t_right pad20_t">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal">
            </el-pagination>
          </div>-->
        </div>
      </el-tab-pane>
      <el-tab-pane label="按客户汇总" name="customer" class="pad10_t">
        <div class="flex flex_wrap">
          <div class="pad20_r pad20_b">
            <span class="pad10_r">客户</span>
            <el-select v-model="customerId" filterable clearable placeholder="请选择" @change="customerIdChange">
              <el-option v-for="(item, index) in customerEntityRes" :key="index" :label="item.name" :value="item.userId"> </el-option>
            </el-select>
          </div>
          <div class="pad20_r pad20_b">
            <span class="pad10_r">客户分组</span>
            <el-select v-model="customerGroupId" filterable clearable placeholder="请选择" @change="customerIdChange">
              <el-option v-for="(item, index) in customerGroupList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
          <div class="pad20_r pad20_b">
            <span class="pad10_r">服务人员</span>
            <el-select v-model="shopStaffId" filterable clearable placeholder="请选择" @change="customerIdChange">
              <el-option v-for="(item, index) in shopStaffList" :key="index" :label="item.boName" :value="item.boIdStr"> </el-option>
            </el-select>
          </div>
          <div class="pad20_r pad20_b">
            <span class="pad10_r">商品</span>
            <el-select v-model="goodsId" filterable clearable placeholder="请选择">
              <el-option v-for="(item, index) in shopGoodsList" :key="index" :label="item.name" :value="item.goodsId"> </el-option>
            </el-select>
          </div>
          <div class="pad20_r pad20_b">
            <span class="pad10_r">订单状态</span>
            <el-select v-model="orderStatus" placeholder="请选择" class="w110">
              <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="pad20_r pad20_b">
            <span class="pad10_r">时间</span>
            <el-date-picker
              v-model="time"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div class="pad20_b">
            <el-button type="primary" @click="query(0)">查询</el-button>
            <el-button type="primary" class="mar30_l" @click="exportSellCollectCustomer">导出</el-button>
            <el-button type="primary" @click="resetGood">重置</el-button>
          </div>
        </div>
        <div v-loading="tableLoad" class="min_width1000">
          <el-table
            class="customerOrderGroup clientTable"
            :data="customerOrderGroupList"
            :row-style="rowStyle"
            :span-method="objectSpanMethodCustomer"
            border
            style="width: 100%; min-width: 1000px"
          >
            <el-table-column label="客户">
              <template slot-scope="scope">
                <span class="c_blue">{{ scope.row.customerName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="serviceName" label="服务人员"> </el-table-column>
            <el-table-column prop="orderGoodsBasisEntity.goodsName" label="货品名称"> </el-table-column>
            <el-table-column prop="orderGoodsBasisEntity.goodsQuantityAll" label="销售数量"> </el-table-column>
            <el-table-column prop="orderGoodsBasisEntity.mSUnit" label="销售单位"> </el-table-column>
            <el-table-column prop="orderGoodsBasisEntity.finalUnitConverAll" label="结算数量"> </el-table-column>
            <el-table-column prop="orderGoodsBasisEntity.goodsSpec" label="结算单位"> </el-table-column>
            <el-table-column prop="orderGoodsBasisEntity.sellFactPrice" label="结算单价"> </el-table-column>
            <el-table-column prop="orderGoodsBasisEntity.totalAmount" label="总价（元）"> </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import { mapState } from "vuex";
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  data() {
    return {
      activeName: "good",
      tableLoad: false,
      currentPage: 1,
      tableData: [],
      time: "",
      orderStatus: "",
      options: [],
      goodsClassifies: [],
      pageTotal: 0,
      pageSize: 30,
      pageNum: 1,
      isOffStand: 1,
      orderMoneyAll: 0,
      goodsIdList: [],
      goodsId: "",
      classifyId: "",
      classifyGoodsMap: [],
      pickerOptions: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const three = 365 * 24 * 3600 * 1000;
          const threeMonths = curDate - three;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      customerGroupList: [],
      customerGroupId: "",
      shopStaffList: [],
      shopStaffId: "",
      customerEntityRes: [],
      checkCustomer: [],
      customerId: "",
      shopGoodsList: [],
      customerOrderGroupList: [],
      typeNameArr: [],
      typeNamePos: 0,
      storeArr: [],
      storePos: 0,
      customerArr: [],
      customerPos: 0,
    };
  },
  computed: mapState({
    showTitle: (state) => state.app.showTitle,
  }),
  created() {
    this.$store.commit("app/setShowTitle", false);
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.time = [this.formatDate(start), this.formatDate(end)];
    this.$store.dispatch("shop/shop/queryShopDtlByBoId").then((res) => {
      if (res.data) {
        this.isOffStand = res.data.isorderconfirm;
        if (this.isOffStand === "1") {
          this.orderStatus = "9";
          this.options = [
            {
              value: "9",
              label: "待审核",
            },
            {
              value: "1",
              label: "待付款",
            },
            {
              value: "2",
              label: "待发货",
            },
            {
              value: "3",
              label: "待收货",
            },
            {
              value: "5",
              label: "已完成",
            },
            {
              value: "8",
              label: "售后",
            },
          ];
        } else {
          this.orderStatus = "0";
          this.options = [
            {
              value: "0",
              label: "全部",
            },
            {
              value: "1",
              label: "待付款",
            },
            {
              value: "2",
              label: "待发货",
            },
            {
              value: "3",
              label: "待收货",
            },
            {
              value: "5",
              label: "已完成",
            },
            {
              value: "8",
              label: "售后",
            },
          ];
        }
        this.query(1);
      }
    });
  },

  mounted() {},
  methods: {
    customerIdChange() {
      this.checkCustomer = [];
      console.log(this.shopStaffId);
      this.customerEntityRes.forEach((item) => {
        if ((this.shopStaffId === '' || (this.shopStaffId !== '' && item.serviceStaffs.length > 0 && this.shopStaffId == item.serviceStaffs[0].staff)) // eslint-disable-line
          &&  (this.customerGroupId === '' || (this.customerGroupId !== '' && item.groupId == this.customerGroupId)) // eslint-disable-line
          &&  (this.customerId === '' || (this.customerId !== '' && item.userId == this.customerId))) { // eslint-disable-line
          this.checkCustomer.push(item);
        }
      });
      console.log(this.checkCustomer);
    },
    classifyIdChange() {
      this.goodsId = "";
      this.goodsIdList = [];
      this.goodsClassifies.forEach((item) => {
        if (item.classifyId === this.classifyId) {
          this.classifyGoodsMap = item.goodsEntityList;
          item.goodsEntityList.forEach((goods) => {
            this.goodsIdList.push(goods.goodsId);
          });
        }
      });
    },
    resetGood() {
      this.time = [];
      this.goodsId = "";
      this.goodsIdList = [];
      this.orderStatus = "";
      this.classifyId = "";
      this.checkCustomer = "";
      this.shopStaffId = "";
      this.customerGroupId = "";
      this.customerId = "";
    },
    query(item) {
      console.log(this.checkCustomer);
      if (!this.checkCustomer.length && this.customerGroupId) {
        this.customerOrderGroupList = [];
        return;
      }
      if (!this.checkCustomer.length && this.shopStaffId) {
        this.customerOrderGroupList = [];
        return;
      }
      let itemFrom = {};
      this.goodsIdList = [];
      if (this.goodsId !== "") {
        this.goodsIdList.push(this.goodsId);
      }
      if (this.orderStatus === "9") {
        itemFrom = {
          isConfirm: 2,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderTimeS: this.time[0],
          orderTimeE: this.time[1],
          goodsIdList: this.goodsIdList,
          type: item,
          selType: this.activeName,
          customerEntityRes: this.checkCustomer,
        };
      } else {
        itemFrom = {
          orderStatus: this.orderStatus,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderTimeS: this.time[0],
          orderTimeE: this.time[1],
          goodsIdList: this.goodsIdList,
          type: item,
          selType: this.activeName,
          customerEntityRes: this.checkCustomer,
        };
      }
      this.$store.dispatch("orderTo/index/getQuerySellCollect", itemFrom).then((res) => {
        console.log(res);
        if (res.data) {
          this.pageTotal = res.data.totalNum;
          if (item === 1) {
            this.goodsClassifies = res.data.goodsClassifies;
            this.customerGroupList = res.data.customerGroupList;
            this.shopStaffList = res.data.shopStaffList;
            this.customerEntityRes = res.data.customerEntityRes;
            this.shopGoodsList = res.data.shopGoodsList;
          }
          this.tableData = [];
          this.customerOrderGroupList = [];
          if (this.activeName === "good") {
            if (res.data.orderGoodsBasisResList !== null && res.data.orderGoodsBasisResList !== undefined && res.data.orderGoodsBasisResList.length > 0) {
              this.tableData = res.data.orderGoodsBasisResList;
              this.orderGoodsBasis(this.tableData);
            }
          } else {
            if (res.data.customerOrderGroupList !== null && res.data.customerOrderGroupList !== undefined && res.data.customerOrderGroupList.length > 0) {
              this.customerOrderGroupList = res.data.customerOrderGroupList;
              this.customerOrderGroup(this.customerOrderGroupList);
            }
          }
        } else {
          this.pageTotal = 0;
          this.tableData = [];
        }
      });
    },
    //  exportSellCollect() {
    //   if (this.orderStatus === '9') {
    // eslint-disable-next-line max-len
    //     window.location.href = `${process.env.VUE_APP_APP}rest/order/exportSellCollect?isConfirm=1&type=1&orderTimeS=${this.time[0]}&orderTimeE=${this.time[1]}&selType=${this.activeName}&goodsIdList=${this.goodsIdList}`;
    //   } else {
    // eslint-disable-next-line max-len
    //     window.location.href = `${process.env.VUE_APP_APP}rest/order/exportSellCollect?type=1&orderStatus=${this.orderStatus}&orderTimeS=${this.time[0]}&selType=${this.activeName}&goodsIdList=${this.goodsIdList}`;
    //   }
    // },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(0);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.query(0);
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.goodsId = "";
      if (this.isOffStand === "1") {
        this.orderStatus = "9";
      } else {
        this.orderStatus = "0";
      }
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.time = [this.formatDate(start), this.formatDate(end)];
      this.classifyId = "";
      this.customerGroupId = "";
      this.shopStaffId = "";
      this.customerId = "";
      this.query(1);
    },
    formatDate(dates) {
      const date = new Date(dates);
      if (date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1 <= 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate();
        const curDate = `${year}-${month}-${day}`;
        return curDate;
      }
      return "";
    },
    // 初始化多规格表格合并单元格所用到的数据
    merageInit() {
      // 在下文的时候会用到，对数据进行初始化是很有必要的
      this.typeNameArr = [];
      this.typeNamePos = 0;
      this.storeArr = [];
      this.storePos = 0;
      this.customerArr = [];
      this.customerPos = 0;
    },
    // 处理多规格表格合并单元格
    // eslint-disable-next-line
    customerOrderGroup(list) {
      this.merageInit(); // 前文的初始化数据函数
      for (let i = 0; i < list.length; i += 1) {
        if (i === 0) {
          // 第一行必须存在
          this.typeNameArr.push(1);
          this.typeNamePos = 0;
          this.storeArr.push(1);
          this.storePos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同,eg：this.typeNamePos 是 this.typeNameArr序号
          // 第一列 下面的是eslint的不限制语法
          // eslint-disable-next-line no-lonely-if
          if (list[i].customerName === list[i - 1].customerName) {
            this.typeNameArr[this.typeNamePos] += 1;
            this.typeNameArr.push(0);
          } else {
            this.typeNameArr.push(1);
            this.typeNamePos = i;
          }
          // 第二列
          if (list[i].serviceName === list[i - 1].serviceName && list[i].customerName === list[i - 1].customerName) {
            this.storeArr[this.storePos] += 1;
            this.storeArr.push(0);
          } else {
            this.storeArr.push(1);
            this.storePos = i;
          }
        }
      }
    },
    // 合并单元格elementui的官方方法
    // eslint-disable-next-line
    objectSpanMethodCustomer(res) {
      const { rowIndex, columnIndex } = res;
      if (columnIndex === 0) {
        // 第一列的合并方法
        const row1 = this.typeNameArr[rowIndex];
        const col1 = row1 > 0 ? 1 : 0; // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row1,
          colspan: col1,
        };
      }
      if (columnIndex === 1) {
        // 第二列的合并方法
        const row2 = this.storeArr[rowIndex];
        const col2 = row2 > 0 ? 1 : 0; // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row2,
          colspan: col2,
        };
      }
    },
    orderGoodsBasis(list) {
      this.merageInit(); // 前文的初始化数据函数
      for (let i = 0; i < list.length; i += 1) {
        if (i === 0) {
          // 第一行必须存在
          this.typeNameArr.push(1);
          this.typeNamePos = 0;
          this.storeArr.push(1);
          this.storePos = 0;
          this.customerArr.push(1);
          this.customerPos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同,eg：this.typeNamePos 是 this.typeNameArr序号
          // 第一列 下面的是eslint的不限制语法
          // eslint-disable-next-line no-lonely-if
          if (list[i].goodsId === list[i - 1].goodsId) {
            this.typeNameArr[this.typeNamePos] += 1;
            this.typeNameArr.push(0);
          } else {
            this.typeNameArr.push(1);
            this.typeNamePos = i;
          }
          // 第二列
          if (list[i].goodsId === list[i - 1].goodsId && list[i].goodsName === list[i - 1].goodsName) {
            this.storeArr[this.storePos] += 1;
            this.storeArr.push(0);
          } else {
            this.storeArr.push(1);
            this.storePos = i;
          }
          // 第三列
          if (list[i].goodsId === list[i - 1].goodsId && list[i].goodsName === list[i - 1].goodsName && list[i].customerName === list[i - 1].customerName) {
            this.customerArr[this.customerPos] += 1;
            this.customerArr.push(0);
          } else {
            this.customerArr.push(1);
            this.customerPos = i;
          }
        }
      }
    },
    // 合并单元格elementui的官方方法
    // eslint-disable-next-line
    objectSpanMethodGoods(res) {
      const { rowIndex, columnIndex } = res;
      if (columnIndex === 0) {
        // 第一列的合并方法
        const row1 = this.typeNameArr[rowIndex];
        const col1 = row1 > 0 ? 1 : 0; // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row1,
          colspan: col1,
        };
      }
      if (columnIndex === 1) {
        // 第二列的合并方法
        const row2 = this.storeArr[rowIndex];
        const col2 = row2 > 0 ? 1 : 0; // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row2,
          colspan: col2,
        };
      }
      if (columnIndex === 2) {
        // 第二列的合并方法
        const row3 = this.customerArr[rowIndex];
        const col3 = row3 > 0 ? 1 : 0; // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row3,
          colspan: col3,
        };
      }
    },
    // 导出表格所用
    // eslint-disable-next-line
    exportSellCollectCustomer() {
      // 设置当前日期
      let time = new Date();// eslint-disable-line
      let year = time.getFullYear();// eslint-disable-line
      let month = time.getMonth() + 1;// eslint-disable-line
      let day = time.getDate();// eslint-disable-line
      let name = year + "" + month + "" + day;// eslint-disable-line
      // console.log(name)
      /* generate workbook object from table */
      //  .table要导出的是哪一个表格
      var wb = XLSX.utils.table_to_book(document.querySelector(".customerOrderGroup"));// eslint-disable-line
      /* get binary string as output */
      var wbout = XLSX.write(wb, {// eslint-disable-line
        bookType: "xlsx",// eslint-disable-line
        bookSST: true,
        type: "array",// eslint-disable-line
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),// eslint-disable-line
          name + ".xlsx" // eslint-disable-line
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);// eslint-disable-line
      }
      return wbout;
    },
    // 导出表格所用
    // eslint-disable-next-line
    exportSellCollectGoods() {
      // 设置当前日期
      let time = new Date();// eslint-disable-line
      let year = time.getFullYear();// eslint-disable-line
      let month = time.getMonth() + 1;// eslint-disable-line
      let day = time.getDate();// eslint-disable-line
      let name = year + "" + month + "" + day;// eslint-disable-line
      // console.log(name)
      /* generate workbook object from table */
      let xlsxParam = { raw: true };// eslint-disable-line
      //  .table要导出的是哪一个表格
      var wb = XLSX.utils.table_to_book(document.querySelector(".goodsOrderGroup"),xlsxParam);// eslint-disable-line
      /* get binary string as output */
      var wbout = XLSX.write(wb, {// eslint-disable-line
        bookType: "xlsx",// eslint-disable-line
        bookSST: true,
        type: "array",// eslint-disable-line
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),// eslint-disable-line
          name + ".xlsx" // eslint-disable-line
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);// eslint-disable-line
      }
      return wbout;
    },
    rowStyle(res) {
      if (!res.row) {
        return "";
      }
      const stylejson = {
        fontWeight: "500",
        backgroundColor: "#fff",
      };
      if ((res.row.orderGoodsBasisEntity && res.row.orderGoodsBasisEntity.goodsName === "小计") || (res.row.customerName && res.row.customerName === "小计")) {
        stylejson.fontWeight = "700";
        stylejson.backgroundColor = "#fafafa";
        return stylejson;
      }
      if (res.row.customerName === "合计") {
        stylejson.fontWeight = "700";
        stylejson.backgroundColor = "#f2f2f2";
        return stylejson;
      }
      return "";
    },
  },
};
</script>
